export default class FormFieldsPerAssetType {

  static get AVAILABLE_FORM_FIELDS(){
    return {
      assetName: "name",
      assetGrossValue: "gross",
      assetCurrency: "assetCurrency",
      assetMonthlyContribution: "monthlyContribution",
      assetEmployerMonthlyContribution: "employerMonthlyContribution",
      assetMonthlyIncome: "monthlyIncome",
      assetInterestRate: "interestRate",
      assetBondInterestRate: "bondInterestRate",
      assetLiability: "liability",
      assetTermOfDebt: "termOfDebt",
      assetMonthlyProfit: "monthlyProfit",
      baseCost: "baseCost"
    };
  };

  static get AVAILABLE_ASSET_TYPES(){
    return {
      retirementAnnuity: "Retirement annuity",
      pension: "Pension",
      provident: "Provident",
      providentPreservation: "Provident preservation",
      pensionPreservation: "Pension preservation",
      unitTrust: "Unit trust",
      sharePortfolio: "Share portfolio",
      endowment: "Endowment",
      offshoreInvestment: "Offshore investment",
      moneyMarket: "Money market",
      investmentProperty: "Investment property",
      otherIncome: "Other income",
      livingAnnuity: "Living annuity",
      taxFreeSavingsAccount: "Tax free savings account"
    };
  };

  static get assetFieldsMapping() {
    return {
      [this.AVAILABLE_ASSET_TYPES.pension]:               (isRetired) => { return this.retirementVehicleFields(isRetired) },
      [this.AVAILABLE_ASSET_TYPES.provident]:             (isRetired) => { return this.retirementVehicleFields(isRetired) },
      [this.AVAILABLE_ASSET_TYPES.retirementAnnuity]:     (isRetired) => { return this.retirementVehicleFields(isRetired) },
      [this.AVAILABLE_ASSET_TYPES.pensionPreservation]:   (_isRetired) => { return this.preservationFields() },
      [this.AVAILABLE_ASSET_TYPES.providentPreservation]: (_isRetired) => { return this.preservationFields() },
      [this.AVAILABLE_ASSET_TYPES.unitTrust]:             (isRetired) => { return this.discretionaryFields(isRetired) },
      [this.AVAILABLE_ASSET_TYPES.sharePortfolio]:        (isRetired) => { return this.discretionaryFields(isRetired) },
      [this.AVAILABLE_ASSET_TYPES.endowment]:             (isRetired) => { return this.discretionaryFields(isRetired) },
      [this.AVAILABLE_ASSET_TYPES.offshoreInvestment]:    (isRetired) => { return this.offshoreInvestmentFields(isRetired) },
      [this.AVAILABLE_ASSET_TYPES.moneyMarket]:           (isRetired) => { return this.moneyMarketFields(isRetired) },
      [this.AVAILABLE_ASSET_TYPES.investmentProperty]:    (_isRetired) => { return this.investmentPropertyFields() },
      [this.AVAILABLE_ASSET_TYPES.otherIncome]:           (_isRetired) => { return this.otherIncomeFields() },
      [this.AVAILABLE_ASSET_TYPES.livingAnnuity]:         (isRetired) => { return this.livingAnnuityFields(isRetired) },
      [this.AVAILABLE_ASSET_TYPES.taxFreeSavingsAccount]: (isRetired) => { return this.taxFreeSavingsAccountFields(isRetired) },
    };
  }

  static fieldsForAsset(assetName, isRetired){
    let fields;
    let fieldsGenerator = this.assetFieldsMapping[assetName]

    if (fieldsGenerator) {
      fields = fieldsGenerator(isRetired)
    } else {
      throw "Unknown asset type in FormFieldsPerAssetType";
    }

    return fields;
  }

  static preservationFields(){
    return [
      [{
        [this.AVAILABLE_FORM_FIELDS.assetName]: {},
      }],
      [{
        [this.AVAILABLE_FORM_FIELDS.assetGrossValue]: {},
      }],
    ];
  }

  static livingAnnuityFields(isRetired){
    let fields = [
      [{
        [this.AVAILABLE_FORM_FIELDS.assetName]: {},
      }],
    ];

    if (isRetired){
      fields.push([{
        [this.AVAILABLE_FORM_FIELDS.assetGrossValue]: {}
      }]);
    } else {
      fields.push([{
        [this.AVAILABLE_FORM_FIELDS.assetGrossValue]: {},
        [this.AVAILABLE_FORM_FIELDS.assetMonthlyIncome]: {},
      }]);
    }

    return fields;
  }

  static retirementVehicleFields(isRetired){
    let fields = [
      [{
        [this.AVAILABLE_FORM_FIELDS.assetName]: {},
      }],
    ];

    if (isRetired){
      fields.push([{
        [this.AVAILABLE_FORM_FIELDS.assetGrossValue]: {}
      }]);
    } else {
      fields.push([{
        [this.AVAILABLE_FORM_FIELDS.assetGrossValue]: {},
        [this.AVAILABLE_FORM_FIELDS.assetMonthlyContribution]: {},
        [this.AVAILABLE_FORM_FIELDS.assetEmployerMonthlyContribution]: {},
      }]);
    }

    return fields;
  }

  static discretionaryFields(isRetired){
    let fields = [
      [{
        [this.AVAILABLE_FORM_FIELDS.assetName]: {},
      }],
    ];

    if (isRetired){
      fields.push([{
        [this.AVAILABLE_FORM_FIELDS.assetGrossValue]: {}
      }]);
    } else {
      fields.push([{
        [this.AVAILABLE_FORM_FIELDS.assetGrossValue]: {},
        [this.AVAILABLE_FORM_FIELDS.assetMonthlyContribution]: {},
      }]);
    }

    if (!isRetired){
      fields.push([{
        [this.AVAILABLE_FORM_FIELDS.assetMonthlyIncome]: {}
      }]);
    }
    return fields;
  }

  static moneyMarketFields(isRetired){
    let fields = [
      [{
        [this.AVAILABLE_FORM_FIELDS.assetName]: {},
      }],
      [{
        [this.AVAILABLE_FORM_FIELDS.assetGrossValue]: {},
        [this.AVAILABLE_FORM_FIELDS.assetInterestRate]: {

          maxValue: 8.0,
          assetType: 'moneyMarket',
          warningMessage: 'A money market return above 8% is unrealistic.'
        },
      }]
    ];

    if (!isRetired){
      fields.push([{
        [this.AVAILABLE_FORM_FIELDS.assetMonthlyContribution]: {},
        [this.AVAILABLE_FORM_FIELDS.assetMonthlyIncome]: {}
      }]);
    }

    return fields;
  }

  static offshoreInvestmentFields(isRetired){
    let fields = [
      [{
        [this.AVAILABLE_FORM_FIELDS.assetName]: {},
      }],
      [{
        [this.AVAILABLE_FORM_FIELDS.assetGrossValue]: {},
        [this.AVAILABLE_FORM_FIELDS.assetCurrency]: {},
      }]
    ];

    if (!isRetired){
      fields.push([{
        [this.AVAILABLE_FORM_FIELDS.assetMonthlyContribution]: {},
        [this.AVAILABLE_FORM_FIELDS.assetMonthlyIncome]: {},
      }]);
    }

    return fields;
  }

  static investmentPropertyFields(){
    return [
      [{
        [this.AVAILABLE_FORM_FIELDS.assetName]: {},
      }],
      [{
        [this.AVAILABLE_FORM_FIELDS.assetGrossValue]: {},
        [this.AVAILABLE_FORM_FIELDS.assetLiability]: {},
      }],
      [{
        [this.AVAILABLE_FORM_FIELDS.assetBondInterestRate]: {},
        [this.AVAILABLE_FORM_FIELDS.assetTermOfDebt]: {},
      }],
      [{
        [this.AVAILABLE_FORM_FIELDS.assetMonthlyProfit]: {},
        [this.AVAILABLE_FORM_FIELDS.assetMonthlyContribution]: {
          labelText: 'Additional Monthly Repayment'
        },
      }],
    ];
  }

  static otherIncomeFields(){
    return [
      [{
        [this.AVAILABLE_FORM_FIELDS.assetName]: {},
      }],
      [{
        [this.AVAILABLE_FORM_FIELDS.assetMonthlyIncome]: {
          labelText: 'What is the gross monthly income?'
        },
        [this.AVAILABLE_FORM_FIELDS.assetInterestRate]: {
          labelText: 'Annual increase in income? %',
          assetType: 'otherIncome'
        },
      }]
    ];
  }

  static taxFreeSavingsAccountFields(isRetired){
    let retirementVehicleFields = this.retirementVehicleFields(isRetired);
    if (!isRetired){
      retirementVehicleFields.push([{
        [this.AVAILABLE_FORM_FIELDS.assetMonthlyIncome]: {}
      }]);
    }
      retirementVehicleFields.push([{
        [this.AVAILABLE_FORM_FIELDS.baseCost]: {}
      }]);
    return retirementVehicleFields;
  }
}
